"use strict";

exports.__esModule = true;
exports.isCourseService = exports.isAppointmentService = void 0;
var _types = require("@wix/ambassador-bookings-services-v2-service/types");
const isCourseService = service => {
  return service.type === _types.ServiceType.COURSE;
};
exports.isCourseService = isCourseService;
const isAppointmentService = service => {
  return service.type === _types.ServiceType.APPOINTMENT;
};
exports.isAppointmentService = isAppointmentService;
//# sourceMappingURL=service.js.map